<div [ngClass]="class">
  <span class="icon"></span>
  <span class="legend">{{ legend }}</span>
</div>
